export default "__VITE_ASSET__ffbdbe9a__"